import { useState, useCallback } from "react";

const useScroll = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  window.addEventListener("scroll", handleScroll);

  return isScrolled;
};

export default useScroll;
